import React, { FC, CSSProperties } from 'react';
import { Button } from '@mui/material';

interface Props {
  href: string;
  text: string;
  sx?: CSSProperties;
}

const styles = {
  button: {
    minWidth: 100,
    color: 'primary.secondary',
    backgroundColor: 'grey.50',
    '&:hover': {
      backgroundColor: 'grey.200',
      opacity: 1.0,
    },
  },
} as const;

const ActionButton: FC<Props> = ({ href, text, sx }) => {
  return (
    <Button href={href} target="_blank" fullWidth sx={{ ...styles.button, ...sx }}>
      {text}
    </Button>
  );
};

export default ActionButton;
